import { render, staticRenderFns } from "./AttributeShortcutToggle.vue?vue&type=template&id=33d6e5dd"
import script from "./AttributeShortcutToggle.vue?vue&type=script&lang=ts"
export * from "./AttributeShortcutToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports